export default __webpack_public_path__ + "static/media/result-mark.ac8142ee.svg";